/* GLO: per-category product preview in the desktop mega menu.
   Hovering a sub-category swaps the featured products on the right for that collection's first 3 products. */
(() => {
  const cache = new Map();
  const money = (v) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(Number(v)); }
    catch (e) { return v; }
  };
  const COLOURS = {
    'color-black': ['black'],
    'color-grey-white': ['gray', 'grey', 'light gray', 'light grey', 'dark gray', 'dark grey', 'cloud', 'white'],
    'color-blue': ['blue', 'dark blue', 'blue muse', 'sky blue', 'dusty blue', 'steel blue', 'electric blue', 'tide'],
    'color-pink-red': ['pink', 'dusty pink', 'desert rose', 'ruby red', 'cherry', 'red'],
    'color-purple': ['purple', 'aubergine', 'mauve'],
    'color-brown': ['brown', 'cocoa', 'mocha'],
    'color-green': ['green', 'sage', 'olive green', 'army green'],
  };
  const tagsOf = (p) => (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(', '));
  /* Order by gender fit for the collection: exact gender first, unisex next, the other gender last. */
  const rank = (p, handle) => {
    const t = tagsOf(p), w = t.includes('Women'), m = t.includes('Men');
    if (handle.startsWith('men-') || handle === 'men') return m && !w ? 0 : m ? 1 : 2;
    return w && !m ? 0 : w ? 1 : 2;
  };
  /* Pick the image + url for a product; for colour collections use the variant of that colour (or skip). */
  function view(p, handle) {
    const imgs = p.images || [];
    const names = COLOURS[handle];
    if (names) {
      const colourOpt = (p.options || []).find((o) => /^(color|colour|cor)$/i.test(o.name));
      const vs = p.variants.filter((v) => [v.option1, v.option2, v.option3].some((o) => o && names.includes(o.toLowerCase())));
      const v = vs.find((x) => x.available) || vs[0];
      if (!v) return null;
      const single = !colourOpt || (colourOpt.values || []).length <= 1;
      let main = v.featured_image ? { src: v.featured_image.src } : null;
      if (single && (!main || /\.png/i.test(main.src))) main = imgs.find((i) => !/\.png/i.test(i.src)) || main || imgs[0];
      if (!main) return null;
      return { main, alt: single ? imgs.find((i) => i.src !== main.src) : null, url: `/products/${p.handle}?variant=${v.id}`, price: v.price };
    }
    const main = imgs.find((i) => !/\.png/i.test(i.src)) || imgs[0];
    return { main, alt: imgs.find((i) => i !== main), url: `/products/${p.handle}`, price: p.variants.reduce((m, v) => Math.min(m, Number(v.price)), Infinity) };
  }
  const img = (src, w) => src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '';

  async function load(handle) {
    if (!cache.has(handle)) {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cache.set(handle, fetch(`${root}collections/${handle}/products.json?limit=30`)
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((d) => {
          const ps = (d.products || []).filter((p) => p.variants.some((v) => v.available));
          const sorted = ps.map((p, i) => [rank(p, handle), i, p]).sort((a, b) => a[0] - b[0] || a[1] - b[1]).map((x) => x[2]);
          return sorted.map((p) => ({ p, view: view(p, handle) })).filter((x) => x.view && x.view.main).slice(0, 3);
        })
        .catch(() => []));
    }
    return cache.get(handle);
  }

  function card({ p, view: v }) {
    return `<li class="mega-menu__content-list-item glo-mega-card">
      <a href="${v.url}" class="glo-mega-card__link">
        <span class="glo-mega-card__media">
          <img src="${img(v.main.src, 600)}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">
          ${v.alt ? `<img class="glo-mega-card__alt" src="${img(v.alt.src, 600)}" alt="" loading="lazy">` : ''}
        </span>
        <span class="glo-mega-card__title">${p.title}</span>
        <span class="glo-mega-card__price">${money(v.price)}</span>
      </a></li>`;
  }

  function wire(mega) {
    const list = mega.querySelector('.mega-menu__content-list--products');
    if (!list || list.dataset.gloWired) return;
    list.dataset.gloWired = '1';
    const original = list.innerHTML;
    let token = 0;
    /* The theme sizes the dropdown backdrop once on open; re-measure after swapping products. */
    const resize = () => requestAnimationFrame(() => {
      const sub = mega.closest('.menu-list__submenu');
      const hc = mega.closest('header-component') || document.querySelector('header-component');
      if (sub && hc && sub.offsetHeight > 0) hc.style.setProperty('--submenu-height', `${sub.offsetHeight}px`);
    });
    const show = async (link) => {
      const m = (link.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
      if (!m) return;
      const my = ++token;
      mega.querySelectorAll('.mega-menu__link.glo-active').forEach((a) => a.classList.remove('glo-active'));
      link.classList.add('glo-active');
      list.classList.add('glo-loading');
      const products = await load(m[1]);
      if (my !== token) return;
      list.classList.remove('glo-loading');
      if (products.length) { list.innerHTML = products.map(card).join(''); resize(); }
    };
    mega.querySelectorAll('.mega-menu__link[href*="/collections/"]').forEach((a) => {
      a.addEventListener('mouseenter', () => show(a));
      a.addEventListener('focus', () => show(a));
      const h = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
      if (h) a.addEventListener('mouseenter', () => load(h[1]), { once: true });
    });
    const parent = mega.closest('.menu-list__list-item');
    const prefetch = () => mega.querySelectorAll('.mega-menu__link[href*="/collections/"]').forEach((a) => {
      const h = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
      if (h) load(h[1]).then((ps) => ps.forEach((x) => { new Image().src = img(x.view.main.src, 600); }));
    });
    if (parent) parent.addEventListener('mouseenter', prefetch, { once: true });
    if (parent) parent.addEventListener('mouseleave', () => { token++; list.innerHTML = original; list.classList.remove('glo-loading'); mega.querySelectorAll('.glo-active').forEach((a) => a.classList.remove('glo-active')); });
  }

  const init = () => document.querySelectorAll('.mega-menu').forEach(wire);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
